import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-spinner-showroom',
    templateUrl: './showroom-exhibit-spinner-page.component.html',
    styleUrls: ['./showroom-exhibit-spinner-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitSpinnerPageComponent {

}
